(function () {

  'use strict';

  angular.module('eclipseApp.brt')
    .factory('brtEndpoint', ['uteEndpoint', 'brt', function(uteEndpoint, brt) {
      return function(newEndpoint) {
        if (brt.isBRTPeriod() && !brt.isBRTSession()) { //need to provide old-XXX features
          var oldEndpoint = eclipseApp.brtEndpoints[newEndpoint];
          if (oldEndpoint) {
            //console.debug('oldEndpoint --->', oldEndpoint);
            return uteEndpoint(oldEndpoint);
          }
        }
        return uteEndpoint(newEndpoint);
      }
    }]);

})();

